module.exports = __webpack_public_path__ + "img/horn-128x128-1512053.7f588978.png";